import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './CSS/Addproduct.css';

function AddProduct() {
    const navigate = useNavigate();
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [productDetails, setProductDetails] = useState({
        'Vehicle Stock': '',
        'Sale Date': '',
        'Year': '',
        'Make': '',
        'Model': '',
        'Vehicle Vin': '',
        'Vehicle Price': '',
        'Buyer Company': '',
        'Buyer Address': '',
        'Buyer City': '',
        'Total Sales': '',
        'Buyer RFC': '',
        'Verified': ''
    });
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const updateDateTime = () => {
            const now = new Date();
            const formatted = now.toISOString()
                .replace('T', ' ')
                .slice(0, 19);
            setCurrentDateTime(formatted);
        };
        updateDateTime();
        const timer = setInterval(updateDateTime, 1000);
        return () => clearInterval(timer);
    }, []);

    const fieldGroups = {
        'Vehicle Details': [
            'Vehicle Stock',
            'Vehicle Vin',
            'Year',
            'Make',
            'Model',
            'Vehicle Price'
        ],
        'Buyer Details': [
            'Buyer Company',
            'Buyer Address',
            'Buyer City',
            'Buyer RFC'
        ],
        'Sale Details': [
            'Sale Date',
            'Total Sales',
            'Verified'
        ]
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await axios.post("https://artinvver.com/product.php", productDetails);
            if (response.data.success) {
                setMessage('Invoice added successfully!');
                setTimeout(() => {
                    navigate('/productlist');
                }, 2000);
            }
        } catch (error) {
            console.error("Error adding Invoice:", error);
            setMessage('Failed to add Invoice.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="product-form-container">
            <div className="product-form-header">
                <div className="header-info">
                    <div className="timestamp">
                        <span>Current Date and Time :</span>
                        <span className="value">{currentDateTime}</span>
                    </div>
                </div>
                <h1>Add New Invoice</h1>
            </div>

            {message && (
                <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-error'}`}>
                    {message}
                </div>
            )}

            <form onSubmit={handleSubmit} className="product-form">
                {Object.entries(fieldGroups).map(([groupName, fields]) => (
                    <div key={groupName} className="form-section">
                        <h2>{groupName}</h2>
                        <div className="fields-grid">
                            {fields.map((field) => (
                                <div key={field} className="form-group">
                                    <label htmlFor={field}>{field}</label>
                                    {field === 'Verified' ? (
                                        <select
                                            id={field}
                                            name={field}
                                            value={productDetails[field]}
                                            onChange={handleChange}
                                            className="form-input"
                                            required
                                        >
                                            <option value="">Select verification status</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    ) : (
                                        <input
                                            id={field}
                                            type={
                                                field === 'Sale Date' ? 'date' :
                                                field === 'Year' || field.includes('Price') || field.includes('Sales') ? 'number' :
                                                'text'
                                            }
                                            name={field}
                                            value={productDetails[field]}
                                            onChange={handleChange}
                                            className="form-input"
                                            placeholder={`Enter ${field.toLowerCase()}`}
                                            required
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                <div className="form-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => navigate('/productlist')}
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Adding...' : 'Add Invoice'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddProduct;